const CureFormGridPluginSettingsView: IPluginSettings = {
    name: 'Лекарственные формы',
    mnemocode: 'cure_form_plugin_view',
    permission: 'CureForm',
    columns: [{
        order: 0,
        propertyName: 'mnemocode',
        propertyType: 'string',
        displayName: 'Мнемокод',
        visibility: true,
        width: 150
    }, {
        order: 1,
        propertyName: 'name',
        propertyType: 'string',
        displayName: 'Наименование',
        visibility: true,
        width: 150
    }, {
        order: 2,
        propertyName: 'federalCode',
        propertyType: 'string',
        displayName: 'Код федеральный',
        visibility: true,
        width: 300
    }, {
        order: 5,
        propertyName: 'idGlobal',
        propertyType: 'string',
        displayName: 'IdGlobal',
        visibility: false,
        width: 157
    }, {
        order: 6,
        propertyName: 'displayName',
        propertyType: 'string',
        displayName: 'DisplayName',
        visibility: false,
        width: 157
    }
    ],
}

export default CureFormGridPluginSettingsView